<template>
  <div>
    <!-- Generate Token Modal -->
    <modal ref="createTokenModal" v-on:token="replaceCode"></modal>

    <!-- Body -->
    <b-row>
      <b-col cols="3"><strong>Code:</strong></b-col>
      <b-col>
        <span v-if="this.token.token" style="font-family: 'Courier New', serif; font-size: larger">{{ this.token.token | uppercase }}</span>
        <span v-else>Keiner</span>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="3"><strong>Gültig ab:</strong></b-col>
      <b-col>
        <span v-if="this.token.validFrom">{{ this.token.validFrom | moment('calendar') }}</span>
        <span v-else>-</span>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="3"><strong>Gültig bis:</strong></b-col>
      <b-col>
        <span v-if="this.token.validUntil">{{ this.token.validUntil | moment('calendar') }}</span>
        <span v-else>-</span>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="3"></b-col>
      <b-col>
        <b-button type="button" size="sm" variant="primary" class="mt-2" v-on:click="newCode">Neuen Code generieren</b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Modal from '@/components/competitions/details/OnlineTokenModal'
export default {
  name: 'CompetitionToken',
  props: ['registrationId'],

  components: {
    modal: Modal
  },

  data: function () {
    return {
      token: ''
    }
  },

  mounted: function () {
    this.load()
  },

  methods: {
    newCode: function () {
      this.$refs.createTokenModal.show(this.registrationId)
    },

    replaceCode: function (token) {
      this.token = token
    },

    load: function () {
      this.axios.get('/registrations/' + this.registrationId + '/token')
        .then((rsp) => {
          this.token = rsp.data
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/competitions/details/OnlineToken.vue